import { render } from "./TermsOfServicePage.vue?vue&type=template&id=71629c10&scoped=true"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=js"

import "./TermsOfServicePage.vue?vue&type=style&index=0&id=71629c10&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71629c10"]])

export default __exports__